import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns today's date in the given time zone, as a local Date at noon.
 * The server runs in UTC, so `new Date()` is already tomorrow for Canadian stores in the
 * evening (after 8pm Eastern / 5pm Pacific). Noon keeps date math clear of DST changes.
 * @param timeZone IANA time zone (e.g. 'America/Toronto')
 */
export function getStoreToday(timeZone: string): Date {
  const today = dayjs().tz(timeZone);
  return new Date(today.year(), today.month(), today.date(), 12);
}
